import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const NavBadge = ({ count }) => {
    if (count === undefined || count <= 0)
        return null;
    return (_jsx("span", { className: "badge bg-danger rounded-pill", children: count }));
};
export default NavBadge;
